/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: dropdown-multi-select-service.ts
 *
 * Created by kyang on 2019-12-05.
 */

function DropdownMultiSelectServiceConstructor (
    this: JS5Object,
    _: JS5Object,
    DropdownService: JS5Object
) {

    //=========//
    // Queries //
    //=========//

    this.hasSelection = (dropdown: JS5Object) => {
        return _.size(dropdown.selection) > 0;
    };

    this.isItemSelected = (dropdown: JS5Object, item: any) => {
        return !!this.hasSelection(dropdown) && DropdownService.getItemIndex(dropdown, dropdown.selection, item) > -1;
    };

    this.areAllEnabledItemsSelected = (dropdown: JS5Object) => {
        return _.chain(dropdown.collection)
            .differenceWith(dropdown.selection, (itemA: any, itemB: any) => {
                return DropdownService.areItemsEqual(dropdown, itemA, itemB);
            })
            .every((unselectedItem: JS5Object) => {
                return DropdownService.isItemDisabled(dropdown, unselectedItem);
            })
            .value();
    };

    this.getSelectionText = (dropdown: JS5Object) => {
        if (_.size(dropdown.selection) > 1) {
            return 'multiple selections';
        } else if (_.size(dropdown.selection) === 1) {
            return DropdownService.getLabel(dropdown, dropdown.selection[0]);
        }
        return undefined;
    };


    //==============//
    // Modification //
    //==============//

    this.toggleItemSelection = (dropdown: JS5Object, newSelectedItem: any) => {
        if (DropdownService.isItemDisabled(dropdown, newSelectedItem)) {
            return;
        }

        // Replace selection object to update listeners also
        let anyItemRemoved = false;
        let newSelection = _.filter(dropdown.selection, (item: any) => {
            let itemsEqual = DropdownService.areItemsEqual(dropdown, item, newSelectedItem);
            anyItemRemoved = anyItemRemoved || itemsEqual;
            return !itemsEqual;
        });
        if (!anyItemRemoved) {
            newSelection.push(newSelectedItem);
        }
        dropdown.selection = newSelection;
    };

    this.setSelection = (dropdown: JS5Object, newSelectedItems: any[]) => {
        dropdown.selection = _.concat(
            _.filter(dropdown.selection, (item: any) => DropdownService.isItemDisabled(dropdown, item)),
            _.filter(newSelectedItems, (item: any) => !DropdownService.isItemDisabled(dropdown, item))
        );
    };

    this.clearSelection = (dropdown: JS5Object) => {
        dropdown.selection = _.filter(dropdown.selection, (item: any) => {
            return DropdownService.isItemDisabled(dropdown, item);
        });
    };
}

angular
    .module('prism-ui.components')
    .service(
        'DropdownMultiSelectService',
        DropdownMultiSelectServiceConstructor
    );
